import { render, staticRenderFns } from "./main.categoria.vue?vue&type=template&id=8a095230"
import script from "./main.categoria.vue?vue&type=script&lang=js"
export * from "./main.categoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports